import { Container, Title, Text, Button, Center, Stack } from '@mantine/core';
import { Link } from 'react-router-dom';
import { IconError404 } from '@tabler/icons-react';

export function NotFoundPage() {
  return (
    <Container py="xl" pt={80}>
      <Center>
        <Stack align="center">
          <IconError404 size={120} stroke={1.5} />
          <Title order={1} ta="center">404 - Siden blev ikke fundet</Title>
          <Text c="dimmed" size="lg" ta="center" maw={500}>
            Beklager, vi kunne ikke finde den side, du ledte efter. Måske har du indtastet adressen forkert, eller siden er blevet flyttet.
          </Text>
          <Button component={Link} to="/" variant="outline" size="md" mt="xl">
            Gå til forsiden
          </Button>
        </Stack>
      </Center>
    </Container>
  );
}
